<div class="container-fluid px-md-2 px-0">
  <div class="row">

    <div class="col-lg-8 col-xl-8">
      <div class="row">
        <q-effectifs class="effectif-container col-lg-6 my-sm-4" [Option]="OptionClient" [RefreshEffectif]="service.RefreshEffectif">
          <ng-template let-Effectif #mytemplate>
            <div *ngIf="Effectif.Email else noMail">{{Effectif.Email}}</div>
            <ng-template #noMail><div class="no-mail">Adresse mail non renseignée</div></ng-template>
            <div *ngIf="Effectif.TelNumMobil else telFixe">{{Effectif.TelNumMobil}}</div>
            <ng-template #telFixe><div>{{Effectif.TelNumFixe}}</div></ng-template>
          </ng-template>
        </q-effectifs>
        <q-effectifs class="effectif-container col-lg-6 my-sm-4" [Option]="OptionStagiaire" [RefreshEffectif]="service.RefreshEffectif">
          <ng-template let-Effectif #mytemplate>
            <!--<i *ngIf="Effectif.IdClient.length == 0" title="Cet apprenant n’est plus lié à un client du stage" class="q-pointer q-c-warning fa-solid fa-triangle-exclamation" style="width: 10px;text-align: center;"></i>-->
            <div *ngIf="Effectif.Email else noMail">{{Effectif.Email}}</div>
            <ng-template #noMail><div class="no-mail">Adresse mail non renseignée</div></ng-template>
            <div *ngIf="Effectif.TelNumMobil else telFixe">{{Effectif.TelNumMobil}}</div>
            <ng-template #telFixe><div>{{Effectif.TelNumFixe}}</div></ng-template>
          </ng-template>
        </q-effectifs>

        <q-effectifs class="effectif-container col-lg-6 my-2 my-sm-4" [Option]="OptionPreinscrits">
          <ng-template let-Effectif #mytemplate>
            <div *ngIf="Effectif.Email else noMail">{{Effectif.Email}}</div>
            <ng-template #noMail><div class="no-mail">Adresse mail non renseignée</div></ng-template>
            <div *ngIf="Effectif.TelNumMobil else telFixe">{{Effectif.TelNumMobil}}</div>
            <ng-template #telFixe><div>{{Effectif.TelNumFixe}}</div></ng-template>
          </ng-template>
        </q-effectifs>
        <q-effectifs class="effectif-container col-lg-6 my-2 my-sm-4" [Option]="OptionFormateur">
          <ng-template let-Effectif #mytemplate>
            <div *ngIf="Effectif.Email else noMail">{{Effectif.Email}}</div>
            <ng-template #noMail><div class="no-mail">Adresse mail non renseignée</div></ng-template>
            <div *ngIf="Effectif.TelNumMobil else telFixe">{{Effectif.TelNumMobil}}</div>
            <ng-template #telFixe><div>{{Effectif.TelNumFixe}}</div></ng-template>
          </ng-template>
        </q-effectifs>


      </div>

    </div>

    <div class="col-lg-4 col-xl-4 my-2 my-sm-4">
      <fieldset class="q-fieldset" style="min-height:450px;height:auto">
        <legend><i class="fas fa-map-marker-alt"></i> Lieu</legend>
        <queoval-lieu (AdresseLieu)="getLieu($event)"></queoval-lieu>
        <div class="my-3" style="height: 450px">
          <q-leaf-map *ngIf="AdresseMap" [Adresse]="AdresseMap" class="mt-3 h-75"></q-leaf-map>
        </div>
      </fieldset>
    </div>

  </div>
</div>
